import { render } from "./CatalogItemPreview.vue?vue&type=template&id=cfacee1e&scoped=true"
import script from "./CatalogItemPreview.vue?vue&type=script&lang=js"
export * from "./CatalogItemPreview.vue?vue&type=script&lang=js"

import "./CatalogItemPreview.vue?vue&type=style&index=0&id=cfacee1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfacee1e"]])

export default __exports__